package one.healthium.profile.navigation.update_initial_weight

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultUpdateInitialWeightComponent(
    componentContext: ComponentContext,
    override val isTargetWeight: Boolean,
    private val onCloseClicked: () -> Unit,
    private val onWeightUpdated: () -> Unit
) : UpdateInitialWeightComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }

    override fun onWeightUpdated() {
        onWeightUpdated.invoke()
    }
}